import React from 'react'
import './aboutcontainer.css'
const AboutContainer = () => {
    return (
        <section>
            <div class="container  " id='about'>
                <div className="col-md-12 top-wrap"  >
                    <div className=" text-center   text-white  border-radiuss  bg-about-banner" >
                        <div className="our-text">
                            Our <span className='text-dark-blue '>Story</span>
                        </div>

                        <div className=' text-white normal-text'  >
                            Lorem ipsum dolor sit amet. 33 internos vitae aut error
                            tenetur ea iu
                            re aspernatur. Qui quia consectetur sit animi eius ut nes
                            ciunt voluptates et tempore delectus At error beatae eum repellat

                            perspiciatis qui quia repellat. Qui maiores dolorem in consequuntur voluptatum ut illum esse a perspiciatis quia id molestiae consectetur aut voluptatem blanditiis rem tenetur repellat. Ut galisum vero vel ratione dolores eos dolor
                            Lorem ipsum dolor sit amet.
                        </div>
                    </div>

                </div>

                <div class="o-t bg-main ">
                    Our <span className='text-dark-blue'>Team Members </span>

                </div>


                <div className="whole-wrapp">

                    <div class=" wrapp">
                        <div class="col-md-6 ">
                            <img class='img-da ' src="./images/aboutus/Rectangle 4424.png" alt="" />

                        </div>
                        <div class="col-md-6   ">
                            <div className='text-cont'>
                                <h2>Name</h2>
                                <h5 className='text-muted'>Designation</h5>
                                <p className=''>Lorem ipsum dolor sit amet. 33 internos vitae aut error tenetur ea iure aspernatur. Qui quia consectetur sit animi
                                    eius ut nesciunt volupta
                                    lotes et tempore delectus At
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto dolores dolor quo impedit consequuntur, natus autem illum. Doloremque quidem magni voluptates. Corporis amet
                                    , placeat quos omnis deserunt laboriosam accusamus commodi!
                                </p>
                            </div>


                        </div>

                    </div>
                    <div class=" wrapp-2">
                        <div class="col-md-6 ">
                            <div className='left text-cont'>
                                <h2>Name</h2>
                                <h5 className='text-muted'>Designation</h5>
                                <p className=''>Lorem ipsum dolor sit amet. 33 internos vitae aut error tenetur ea iure aspernatur. Qui quia consectetur sit animi
                                    eius ut nesciunt volupta
                                    lotes et tempore delectus At
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto dolores dolor quo impedit consequuntur, natus autem illum. Doloremque quidem magni voluptates. Corporis amet
                                    , placeat quos omnis deserunt laboriosam accusamus commodi!
                                </p>
                            </div>


                        </div>
                        <div class="col-md-6    ">

                            <img className='float-start' class='img-da float-start' src="./images/aboutus/Rectangle 4424.png" alt="" />

                        </div>

                    </div>
                    <div class=" wrapp">
                        <div class="col-md-6 ">
                            <img class='img-da ' src="./images/aboutus/Rectangle 4424.png" alt="" />

                        </div>
                        <div class="col-md-6   ">
                            <div className=' text-cont'>
                                <h2>Name</h2>
                                <h5 className='text-muted'>Designation</h5>
                                <p className=''>Lorem ipsum dolor sit amet. 33 internos vitae aut error tenetur ea iure aspernatur. Qui quia consectetur sit animi
                                    eius ut nesciunt volupta
                                    lotes et tempore delectus At
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto dolores dolor quo impedit consequuntur, natus autem illum. Doloremque quidem magni voluptates. Corporis amet
                                    , placeat quos omnis deserunt laboriosam accusamus commodi!
                                </p>
                            </div>


                        </div>

                    </div>
                </div>





                <div class="d-flex justify-content-center mt-5 ">
                    <h1>Our <span className='text-dark-blue'>Values</span> </h1>

                </div>
                <div className="d-flex justify-content-center">
                    <div className="rep-wrap">
                        <div className="box" style={{ background: 'rgba(253, 150, 68, 0.18)' }}>
                            <h3 style={{  color: "rgba(128, 0, 128, 0.81)"}}>Customer Focus</h3>
                            <p>Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                                Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                            </p>
                        </div>
                        <div className="box" style={{ background: 'rgba(253, 150, 68, 0.18)' }} >
                            <h3  style={{  color: "rgba(128, 0, 128, 0.81)"}}>Customer Focus</h3>
                            <p>Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                                Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center">
                    <div className="rep-wrap" >
                        <div className="box" style={{ background: "rgba(128, 0, 128, 0.18)" }}>
                            <h3 style={{  color: "#FF8522"}}>Customer Focus</h3>
                            <p>Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                                Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                            </p>
                        </div>
                        <div className="box" style={{ background: "rgba(128, 0, 128, 0.18)" }}>
                            <h3 style={{  color: "#FF8522"}}>Customer Focus</h3>
                            <p>Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                                Lorem ipsum dolor sit amostrum. Harum, exercitationem!
                            </p>
                        </div>
                    </div>
                </div>




            </div>
        </section>
    )
}

export default AboutContainer